/* eslint-disable import/first */
import React from 'react';

import { FormattedMessage } from 'react-intl';
import { Button } from '@material-ui/core';

import noImg from '../../assets/no-itm.png';
import css from './index.module.scss';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
const UpsellItem = ({ cart, index, profile, item, menu, handleAddCart, setCount, currency }) => {
  const list = cart.find((each) => each?.id === item?.id);

  if (list) {
    return '';
  }
  if (!cart.length) {
    return '';
  }
  return (
    <>
      <div className={css.upsellItem} key={index}>
        <div className={css.img}>
          <img
            src={item?.assets[0].src}
            alt=""
            width="120"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = noImg;
            }}
          />
        </div>
        <div className={css.title}>{item?.name}</div>
        <div className={css.buttons}>
          <div className={css.price}>
            <span>{decimalChecker(item?.specialPrice || item?.originalPrice)} {currency}</span>
          </div>
          <div className={css.sub}>
            <Button onClick={() => handleAddCart(item)}>
              + <FormattedMessage id="producttile_add" defaultMessage="Add" />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default UpsellItem;
